import PropTypes from "prop-types";
import React from "react";
import { getImageUrl } from "utils/helpers";
import iconPerson from "images/ic_person.png";
import styled from "styled-components";
import theme from "styles/theme";

const Container = styled.div`
  position: relative;
  width: ${(props) => props.$size || 64}px;
  min-width: ${(props) => props.$size || 64}px;
  max-width: ${(props) => props.$size || 64}px;
  height: ${(props) => props.$size || 64}px;

  ${theme.media.phone`
    ${(props) =>
      props.$mobileSize &&
      `
      width: ${props.$mobileSize || 64}px;
      min-width: ${props.$mobileSize || 64}px;
      max-width: ${props.$mobileSize || 64}px;
      height: ${props.$mobileSize || 64}px;
    `}
  `};
`;

const Background = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: ${(props) => props.$borderColor || theme.colors.white};
  border-radius: 50%;
`;

const Image = styled.img`
  position: absolute;
  top: ${(props) => (props.$borderWidth === 0 ? 0 : props.$borderWidth || 2)}px;
  left: ${(props) =>
    props.$borderWidth === 0 ? 0 : props.$borderWidth || 2}px;
  width: calc(
    100% -
      ${(props) =>
        (props.$borderWidth === 0 ? 0 : props.$borderWidth || 2) * 2}px
  );
  height: calc(
    100% -
      ${(props) =>
        (props.$borderWidth === 0 ? 0 : props.$borderWidth || 2) * 2}px
  );
  border-radius: 50%;
`;

const Headshot = ({
  className,
  src,
  size,
  mobileSize,
  borderColor,
  borderWidth,
  alt,
  speaker,
}) => {
  let _alt = alt;
  if (speaker) {
    _alt = `${speaker.firstName} ${speaker.lastName} headshot`;
  }

  return (
    <Container className={className} $size={size} $mobileSize={mobileSize}>
      <Background $borderColor={borderColor} />
      <Image
        src={src ? getImageUrl(src, "jpg", 300) : iconPerson}
        $borderWidth={borderWidth}
        alt={_alt}
      />
    </Container>
  );
};

Headshot.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string,
  size: PropTypes.number,
  borderColor: PropTypes.string,
  borderWidth: PropTypes.number,
};

export default Headshot;
